RivalIQ.apps.Analyze.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Chart = RivalIQ.views.ItemView.mixin({
        template: false,
        minHeight: 330,
        itemHeight: 26,
        className: 'panel-body',

        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            companySetChangeReload: RivalIQ.apps.Shell.mixins.CompanySetChangeReload
        },

        behaviors: function () {
            const me = this;

            if (me.shouldListenForResize()) {
                return {
                    Resizes: {
                        handler: 'onWindowResize',
                        behaviorClass: RivalIQ.graph.behaviors.Resizes
                    }
                };
            }
        },

        showContentModal: function (company, timePeriod) {
            const me = this;

            const metric = me.dashboardModel.metrics[0];
            const source = RivalIQ.data.channels.get(metric.channel).id;
            // NOTE omit metrics from props b/c we want the PostModal to
            // determine the metrics

            const compareAgainst = _.get(company, ['company', 'compareAgainst']);
            if (compareAgainst) {
                company = undefined;
            }

            const postModalProps = _.omit(me.dashboardModel.getProps(), 'metrics', 'useUniversalMetricsApi');

            // This is a little hacky, it's necessary because those 5 metrics imply a post filter in an addition to a measure. See #34303
            if (_.includes(['all_count', 'all_avg_count_per_day', 'all_avg_count_per_week', 'avg_count_per_day', 'avg_count_per_week'], metric.property) && metric.channel === 'twitter') {
                let tweetTypes = metric.tweetType || _.keys(RivalIQ.enums.tweetTypes);
                if (!_.isArray(tweetTypes)) {
                    tweetTypes = [tweetTypes];
                }
                postModalProps.tweetType = _.map(tweetTypes, tweetType => RivalIQ.enums.tweetTypes[tweetType].id);
            }

            RivalIQ.apps.SocialPosts.views.PostsModal.show(postModalProps, source, company, timePeriod, compareAgainst);
        },

        onAttachLoaded: _.noop,

        initialize: function (options) {
            const me = this;
            const opts = options || {};

            _.extend(me, _.pick(opts, 'width', 'height'));

            const primaryMetric = me.getProp('metrics')[0];
            me.primaryMetric = new RivalIQ.models.MetricDefinition(primaryMetric);
        },

        onWindowResize: function () {
            const me = this;

            if (me.getOption('staticWidth') || !me.isLoadingComplete()) {
                return false;
            }

            // NOTE: if the browser does not support contains, then...sorry
            let isInDom = true;
            // check to see if this dude is in the DOM, because if it isn't
            // then we are probably in a stale view that is generally just being a bum
            if (_.isFunction(document.body.contains)) {
                isInDom = document.body.contains(me.el);
            }

            // if this view is not in the DOM, then kill yourself, and leave
            if (!isInDom) {
                me.remove();
                return;
            }

            // this view is in the dom, and we can check if it has a parent
            const parent = me.$el.parent();

            if (parent) {
                me.width = me.$el.width();
                me.triggerMethod('show');
                me.onAttachLoaded();
            }
        },

        shouldListenForResize: _.constant(true),

        getGraph: function () {

            throw new Error('not implemented');
        },

        submetricsExist: function () {

            const me = this;
            const submetrics = me.getSubmetrics();
            return (submetrics && submetrics.length);
        },

        getWidth: function () {
            const me = this;

            let width = me.width;
            // NOTE if a width was not set then we should try to determine
            // it by examining our ancestors (the parent nodes)
            if (isNaN(width)) {
                let el = me.$el;
                while (!el.width()) {
                    el = el.parent();
                }
                width = el.width();
            }

            return width;
        }
    });
});
